import { render, staticRenderFns } from "./TypeTextImageButton.vue?vue&type=template&id=5d4053ca&scoped=true"
import script from "./TypeTextImageButton.vue?vue&type=script&lang=js"
export * from "./TypeTextImageButton.vue?vue&type=script&lang=js"
import style0 from "./TypeTextImageButton.vue?vue&type=style&index=0&id=5d4053ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4053ca",
  null
  
)

export default component.exports